import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const cards = [
    { icon: 'ri-search-eye-line', title: t('trust.card1.title'), desc: t('trust.card1.desc') },
    { icon: 'ri-shield-check-line', title: t('trust.card2.title'), desc: t('trust.card2.desc') },
    { icon: 'ri-stack-line', title: t('trust.card3.title'), desc: t('trust.card3.desc') },
    { icon: 'ri-safe-line', title: t('trust.card4.title'), desc: t('trust.card4.desc') },
  ];

  const stats = [
    { value: '12,500+', label: t('stats.users') },
    { value: '3,200+', label: t('stats.products') },
    { value: '14', label: t('stats.categories') },
    { value: '98%', label: t('stats.satisfaction') },
  ];

  return (
    <section className="w-full bg-accent-50/50">
      <div className="w-full px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/50 rounded-full mb-5">
              <span className="text-xs font-medium text-accent-700">Kakobuy Spreadsheet</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
              {t('trust.title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {cards.map((card, idx) => (
              <div key={idx} className="bg-background-50 rounded-2xl p-6 md:p-8 text-center group hover:bg-background-50 transition-colors">
                <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                  <i className={`${card.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, idx) => (
              <div key={idx} className="text-center">
                <p className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-1">{stat.value}</p>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}